import store from "@redux/store";
import { LIMITS_DATA, LIMITS_ERROR_DATA, LIMITS_HIDE_ERROR_DATA, LIMITS_START_LOADER, LIMITS_STOP_LOADER, } from "../interface/ILimits";
var LimitsActions = /** @class */ (function () {
    function LimitsActions() {
        this.dispatch = store.dispatch;
    }
    LimitsActions.prototype.getLimits = function (limits) {
        this.dispatch({
            type: LIMITS_DATA,
            payload: { limits: limits },
        });
    };
    LimitsActions.prototype.setError = function (payload, errorType) {
        this.dispatch({
            type: LIMITS_ERROR_DATA,
            payload: { errorData: payload },
        });
    };
    LimitsActions.prototype.hideError = function (errorType) {
        this.dispatch({
            type: LIMITS_HIDE_ERROR_DATA,
        });
    };
    LimitsActions.prototype.loader = function () {
        this.dispatch({
            type: LIMITS_START_LOADER,
        });
    };
    LimitsActions.prototype.stopLoader = function () {
        this.dispatch({
            type: LIMITS_STOP_LOADER,
        });
    };
    return LimitsActions;
}());
export default LimitsActions;
